module.exports = __webpack_public_path__ + "static/media/norfolk-island.5276e86a.svg";